import { render, staticRenderFns } from "./TraffictViolationUpload.vue?vue&type=template&id=9ae5c82c&scoped=true"
import script from "./TraffictViolationUpload.vue?vue&type=script&lang=js"
export * from "./TraffictViolationUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae5c82c",
  null
  
)

export default component.exports